import { EditProfileRole } from "@/src/models/user.model";
import { useTranslation } from "react-i18next";
import { Pressable, Text, View } from "react-native";
import ScCheckbox from "@/src/components/ui-kit/checkbox";

type RoleSectionProps = Readonly<{
  canEditRole: boolean;
  selectedRoles: EditProfileRole[];
  onToggleRole: (role: EditProfileRole) => void;
}>;

const RoleSection = ({
  canEditRole,
  selectedRoles,
  onToggleRole,
}: RoleSectionProps) => {
  const { t } = useTranslation();

  // Super-admins are managed elsewhere; never expose their role editing here.
  if (selectedRoles.includes("super-admin")) return null;

  return (
    <>
      <Text className="text-base text-slate">
        {t("LABEL_CHOOSE_A_ROLE_FOR_THE_USER")}
      </Text>
      <View className="flex-row gap-4 mt-2">
        {(["admin", "member"] as const).map((role) => {
          const isSelected = selectedRoles.includes(role);
          const roleTranslationKey =
            role === "admin" ? "LABEL_ADMIN" : "LABEL_MEMBER";

          return (
            <Pressable
              key={role}
              onPress={() => canEditRole && onToggleRole(role)}
              className={`flex-row items-center gap-2 flex-1 px-3 py-2 rounded-[10px] border ${
                isSelected
                  ? "border-primary bg-primary-2 hover:bg-primary-2"
                  : "border-ash-3 bg-ash hover:bg-ash-3"
              }`}
            >
              <ScCheckbox
                value={isSelected}
                onChange={() => canEditRole && onToggleRole(role)}
                disabled={!canEditRole}
              />
              <Text className="text-base text-onyx font-medium">
                {t(roleTranslationKey)}
              </Text>
            </Pressable>
          );
        })}
      </View>
    </>
  );
};

export default RoleSection;
